import { defineComponent as _defineComponent } from 'vue'
import {computed, getCurrentInstance} from "vue";
import {usePayoutCountries} from "@/components/forms/payout/countries";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {removeDiacritics} from "capitalist-shared/src/tools/text";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutCountriesDropdown',
  props: {
  value: {
    type: String,
    required: false
  },
  valueKey: {
    type: String,
    default: 'alpha2'
  },
  nameKey: {
    type: String,
    default: 'name'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  limit: {
    type: Array,
    default: () => []
  },
  showKeyInName: {
    type: Boolean,
    default: false
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;




const showKeyInName = computed(() => props.showKeyInName);

const countriesData = usePayoutCountries();

const ucFirst = (str: string) => {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
}

const limitedCountries = computed(() => {
  if (!countriesData.data.value) return [];
  if (!props.limit || props.limit.length == 0)
    return countriesData.data.value;

  return countriesData.data.value.filter((country: any) => props.limit.includes(country[props.valueKey || 'alfa2']));
})

const countries = computed(() => {
  if (!limitedCountries.value) return [];
  const $i18n = getCurrentInstance().proxy?.$i18n;
  const lang = $i18n?.locale || 'en';
  const nameKey = (props.nameKey || 'name') + ucFirst(lang);

  let result = {};

  for (let country of limitedCountries.value) {
    result[country[props.valueKey || 'alfa2']] = country[nameKey];
  }

  return result;
})

const localizedNameKey = computed(() => {
  const $i18n = getCurrentInstance().proxy?.$i18n;
  const lang = $i18n?.locale || 'en';
  return (props.nameKey || 'name') + ucFirst(lang);
})

const countryOptions = computed(() => {
  if (!limitedCountries.value) return [];

  const key = props.valueKey || 'alpha2';

  return limitedCountries.value.map((country: any) => {
    const normalizedName = showKeyInName.value ? removeDiacritics(country[localizedNameKey.value]) + ' (' + country[key] + ')' : removeDiacritics(country[localizedNameKey.value]);

    return {
      ...country,
      normalizedName,
      filterValue: removeDiacritics(country.nameRu) + ' ' + removeDiacritics(country.nameEn)
        + ' ' + country.alpha2 + ' ' + country.alpha3,
    }
  });
})

const inputDisabled = computed(() => {
  return props.disabled || !countriesData.data.value;
})

const val = computed({
  get: () => props.value,
  set: (value) => {
    emit('input', value)
  }
})


const selectedCountry = computed(() => {
  if (!val.value) return null;
  return countryOptions.value.find(country => country[props.valueKey] === val.value)
})

return { __sfc: true,props, emit, showKeyInName, countriesData, ucFirst, limitedCountries, countries, localizedNameKey, countryOptions, inputDisabled, val, selectedCountry, PrimeDropdown }
}

})